<template>
  <div :class="{'borderless': showDetailedView}">
    <div class="border-bottom search-box" :class="{'focus-input': focussed}" v-if="!showDetailedView">
      <label class="field-title" :class="{'on': focussed}">
        {{searchLabel}}
      </label>
      <span v-if="focussed" @mousedown="showDetailedView = true" class="enter-manual-class">
      Click here to enter manually.
      </span>
      <input type="text" id="billing-address" name="billingAddress" placeholder="" @focus="focussed = true" @blur="focussed = false" ref="gmap_input"/>
    </div>
    <div class="address show" :class="{'focus-input': focussed}" v-if="showDetailedView">
      <template v-for="field in fieldsWithFullWidth">
        <text-field :config="field" v-model="values[field.name]" v-if="field.type === 'text'"> </text-field>
      </template>

      <template v-for="field in doubleFields">
        <!-- TODO handle odd number cases -->
        <div class="clearfix double-address-fields" v-if="field.length == 2">
          <!-- TODO refactor -->
          <text-field :customclass="'left'" :config="field[0]" v-model="values[field[0].name]" v-if="field[0].type === 'text'"> </text-field>

          <select-box :customclass="'left'" :config="field[0]" v-model="values[field[0].name]" v-if="field[0].type === 'select'"> </select-box>

          <text-field :customclass="'right'" :config="field[1]" v-model="values[field[1].name]" v-if="field[1].type === 'text'"> </text-field>

          <select-box :customclass="'right'" :config="field[1]" v-model="values[field[1].name]" v-if="field[1].type === 'select'"> </select-box>
        </div>

        <template v-if="field.length == 1">
          <text-field :config="field[0]" v-model="values[field[0].name]" v-if="field[0].type === 'text'"> </text-field>

          <select-box :config="field[0]" v-model="values[field[0].name]" v-if="field[0].type === 'select'"> </select-box>
        </template>
      </template>
    </div>
  </div>
</template>

<script type="text/javascript">
  import AddressExtractor from "./../helpers/address-extractor";
  import TextField from "./TextField.vue";
  import SelectField from "./SelectField.vue";

  class Constants {
    static get DOUBLE_FIELDS() {
      return [
        "city",
        "region",
        "country",
        "zip",
        "billing_city",
        "billing_region",
        "billing_country",
        "billing_zip"
      ]
    }
  }
  export default {
    name: 'address-component',
    data() {
      return {
        focussed: false,
        autocomplete: undefined,
        showDetailedView: false
      }
    },
    components: {
      'text-field' : TextField,
      'select-box': SelectField
    },
    props: ['fields', 'values', 'label'],
    mounted() {
      // TODO check if autocomplete object is loaded
      if(this.fields.filter(key => this.values[key.name]).length > 0) {
        this.showDetailedView = true;
      }

      this.autocomplete = new google.maps.places.Autocomplete(this.$refs.gmap_input,
        { types: ['address'], output: 'json' });

      this.autocomplete.addListener('place_changed', function(){
        var addressComponents = this.autocomplete.getPlace().address_components;
        console.log(addressComponents);
        var extractedValues = AddressExtractor.extractAddress(addressComponents);
        console.log(extractedValues);

        this.fields.forEach(field => {
          var shortName = field.id.split('.')[1];
          this.values[field.name] = extractedValues[shortName] || ( AddressExtractor.ALIASES[shortName] && extractedValues[AddressExtractor.ALIASES[shortName]] )
        });

        this.showDetailedView = true;
      }.bind(this));
    },
    computed: {
      fieldsWithFullWidth() {
        return this.fields.filter(f => Constants.DOUBLE_FIELDS.indexOf(f.id.split('.')[1]) == -1);
      },

      doubleFields() {
        var tmpMap = this.fields.filter(f => Constants.DOUBLE_FIELDS.indexOf(f.id.split('.')[1]) != -1).reduce((o, f) => {
          o[f.id.split('.')[1]] = f;
          return o;
        },{});

        return Constants.DOUBLE_FIELDS.map(f => tmpMap[f]).filter(v => !!v).reduce((coll, f, index) => {
            var last = coll.length > 0 ? coll[coll.length - 1] : undefined;
            if(last && last.length < 2) {
              last.push(f);
            }
            else {
              coll.push([f])
            }
            return coll;
          },[]);
      },

      searchLabel() {
        return this.focussed ? "Start typing your address" : this.label;
      }
    }
  }
</script>
<style scoped>
  /*TODO CHANGE*/
  .search-box {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0;
    top: 0;
  }
  .borderless {
    border: none;
  }
  span.enter-manual-class {
    top: 0px;
    right: 0px;
    position: absolute;
    cursor: pointer;
    font-size: 12px;
    line-height: 21px;
    color: #007FE1;
    font-weight: 300;
  }
  .search-box input {
    margin-top: 15px;
  }
</style>


// WEBPACK FOOTER //
// AddressComponent.vue?12a71da8